module.exports = {
    /**
     * DESIGN TOKENS
     */
    get R() {
        return require('./core-res/R').default;
    },
    get createStyles() {
        return require('./core-res/R').createStyles;
    },
    get ThemeDefault() {
        return require('./core-res/ThemeDefault').color;
    },
    get ThemeDark() {
        return require('./core-res/ThemeDark').color;
    },
    /**
     * STANDARD COMPONENTS
     */
    get DRNCardView() {
        return require('./standard/Card/DRNCardView').default;
    },
    get DRNButton() {
        return require('./standard/Button/DRNButton').default;
    },
    get DRNInputField() {
        return require('./standard/InputField').default;
    },
    get DRNSwitch() {
        return require('./standard/Switch/DRNSwitch').default;
    },
    get DRNText() {
        return require('./standard/Text/DRNText').default;
    },
    get DRNTouchableWrapper() {
        return require('./standard/Button/TouchableButtonWrapper').default;
    },
    get DRNRadioButton() {
        return require('./standard/RadioButton').default;
    },
    get DRNRadioButtonGroup() {
        return require('./standard/RadioButtonGroup').default;
    },
    get DRNCheckbox() {
        return require('./standard/Checkbox').default;
    },
    get DRNCheckboxGroup() {
        return require('./standard/CheckboxGroup').default;
    },
    get DRNImage() {
        return require('./standard/Image/DRNImage').default;
    },
    get DRNHtmlText() {
        return require('./standard/HtmlText/DRNHtmlText').default;
    },
    get DRNSnackbarContainer() {
        return require('./standard/SnackbarContainer').default;
    },
    get withSnackbar() {
        return require('./standard/SnackbarContainer/withSnackbar').default;
    },
    get DRNSnackbar() {
        return require('./standard/Snackbar').default;
    },
    get DRNContainer() {
        return require('./standard/Anatomy/Container').default;
    },
    get DRNSlider() {
        return require('./standard/Slider').default;
    },
    get DRNBadge() {
        return require('./standard/Badge').default;
    },
    get DRNModal() {
        return require('./standard/Modal').default;
    },
    get DRNDatePicker() {
        return require('./standard/DatePicker').default;
    },
    get DRNTextInputHeader() {
        return require('./standard/Anatomy/Header/TextInputHeader').default;
    },
    get DRNLoadingIndicator() {
        return require('./standard/LoadingIndicator').default;
    },
    get DRNTooltip() {
        return require('./standard/Tooltip/DRNTooltip').default;
    },
    get DRNCarousel() {
        return require('./standard/Carousel').default;
    },
    get DRNNewIndicator() {
        return require('./standard/NewIndicator').default;
    },
    /**
     * COMPOSITE COMPONENTS
     */
    get DRNTray() {
        return require('./composite/Tray').default;
    },
    get DRNStepper() {
        return require('./composite/Stepper').default;
    },
    get DRNCollapsible() {
        return require('./composite/Collapsible').default;
    },
    get DRNProgressBar() {
        return require('./composite/ProgressBar').default;
    },
    get DRNDrillDown() {
        return require('./composite/DrillDown').default;
    },
    get DRNPopup() {
        return require('./composite/Popup').default;
    },
    get DRNInfoBox() {
        return require('./composite/InfoBox').default;
    },
    get DRNBreadCrumb() {
        return require('./composite/Breadcrumb').default;
    },
    get DRNCellItem() {
        return require('./composite/CellItem').default;
    },
    get DRNCalendar() {
        return require('./composite/Calendar').default;
    },
    get DRNDateCell() {
        return require('./composite/DateCell').default;
    },
    get DRNTimer() {
        return require('./composite/Timer').default;
    },
    get DRNTabBar() {
        return require('./composite/TabBar').default;
    },
    get DRNNavBar() {
        return require('./composite/NavBar').default;
    },
    get DRNHolidayList() {
        return require('./composite/HolidayList').default;
    },
    /**
     * UTILITIES
     */
    get flipOnRTL() {
        return require('./utils/image/flipOnRTL').default;
    },
    get resizeImage() {
        return require('./utils/image/resizeImage').default;
    },
    /**
     * THEME SUPPORT
     */
    get ThemeContext() {
        return require('./theme').ThemeContext;
    },
    get ThemeProvider() {
        return require('./theme').ThemeProvider;
    },
    get ThemeConsumer() {
        return require('./theme').ThemeConsumer;
    },
    get withTheme() {
        return require('./theme').withTheme;
    },
    get ThemeAPI() {
        return require('./theme/ThemeManager').ThemeAPI;
    },
    get ThemeConfig() {
        return require('./theme/ThemeManager').ThemeConfig;
    },
    get ThemeAPIContext() {
        return require('./theme/ThemeManager').ThemeAPIContext;
    },
    get withThemeAPI() {
        return require('./theme/ThemeManager').withThemeAPI;
    },
    get ThemeManager() {
        return require('./theme/ThemeManager').ThemeManager;
    },
    /**
     * WITH SMARTKEY SUPPORT
     */
    get withSmartKey() {
        return require('./smartkey').withSmartKey;
    },
    get SmartKeyProvider() {
        return require('./smartkey').SmartKeyProvider;
    },
    get SmartKeyConsumer() {
        return require('./smartkey').SmartKeyConsumer;
    },
};
